import { stockPageChunks } from './stock-first-core.js';

async function stockFirst(section) {
  if (section.dataset.stockInitialized) return;
  section.dataset.stockInitialized = 'true';
  const url = new URL(location.href);
  const explicit = new Set(url.searchParams.getAll('filter.v.availability'));
  if (explicit.size === 1 || document.body.dataset.preview === 'true') return;
  const available = Number(section.dataset.availableCount);
  const unavailable = Number(section.dataset.unavailableCount);
  const total = Number(section.dataset.total);
  const size = Number(section.dataset.pageSize);
  if (available < 0 || unavailable < 0 || available + unavailable !== total) return;
  const status = section.querySelector('[data-stock-status]');
  if (!available || !unavailable) {
    status.hidden = false;
    status.textContent = section.dataset.ready;
    return;
  }
  const page = Math.max(1, Number(url.searchParams.get('page')) || 1);
  const chunks = stockPageChunks(available, unavailable, page, size);
  if (!chunks.length) return;
  const grid = section.querySelector('.product-grid');
  status.hidden = false;
  status.textContent = section.dataset.loading;
  grid.setAttribute('aria-busy', 'true');
  section.classList.add('stock-order-loading');
  try {
    const pages = await Promise.all(chunks.map(async chunk => {
      const source = new URL(url);
      source.searchParams.delete('filter.v.availability');
      source.searchParams.set('filter.v.availability', chunk.stock);
      source.searchParams.set('page', String(chunk.page));
      source.searchParams.set('section_id', 'collection-stock-slice');
      const response = await fetch(source, { signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('Collection unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const slice = doc.querySelector('[data-stock-slice]');
      const cards = [...(slice?.querySelectorAll('.product-card') || [])];
      const expected = chunk.stock === '1' ? available : unavailable;
      if (!slice || Number(slice.dataset.count) !== expected) throw new Error('Inventory changed');
      const result = cards.slice(chunk.skip, chunk.skip + chunk.take);
      if (result.length !== chunk.take) throw new Error('Incomplete collection');
      return result;
    }));
    grid.replaceChildren(...pages.flat());
    section.dataset.stockSorted = 'true';
    status.textContent = section.dataset.ready;
  } catch (_) {
    status.textContent = section.dataset.fallback;
  } finally {
    grid.removeAttribute('aria-busy');
    section.classList.remove('stock-order-loading');
  }
}

document.querySelectorAll('[data-stock-collection]').forEach(stockFirst);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-stock-collection]').forEach(stockFirst));
